import React from "react";
import SectionHeader, { SectionWrapper, Reveal } from "./SectionHeader";
import { Megaphone, Flame, Target, BookOpen, Landmark } from "lucide-react";

const DEPLOYMENTS = [
  { icon: Megaphone, label: "Social Storytelling", note: "Feeds · Shorts · Longform", color: "#00F0FF" },
  { icon: Flame, label: "Viral Content", note: "Moment engineering", color: "#FF00FF" },
  { icon: Target, label: "Brand Campaigns", note: "Creative · Media · Impact", color: "#FFDE00" },
  { icon: BookOpen, label: "Narrative Building", note: "Long-cycle perception", color: "#00F0FF" },
  { icon: Landmark, label: "Government Awareness", note: "Public-interest comms", color: "#FF00FF" },
];

const WhatWeDo = () => {
  return (
    <SectionWrapper id="whatwedo">
      <SectionHeader
        code="// CH.06 — OPERATIONS"
        title="Ops.Stack"
        kicker="Engineering high-impact narratives that command attention — across every surface that matters."
        tid="whatwedo"
      />

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
        {/* Highlight */}
        <Reveal className="lg:col-span-5">
          <div className="glass-card hud-corners p-8 md:p-10 h-full relative overflow-hidden">
            <span className="hud-tr" />
            <span className="hud-bl" />
            <div className="micro-label text-yellow-300 mb-4">PRIMARY CAPABILITY</div>
            <div
              className="font-display font-black uppercase leading-[0.9] tracking-tighter break-words"
              style={{ fontSize: "clamp(2.5rem, 7vw, 6rem)" }}
            >
              <span className="text-yellow-300 glow-yellow">360°</span>
              <br />
              Impact
            </div>
            <p className="mt-6 text-white/70 text-sm md:text-base max-w-sm leading-relaxed">
              Full-spectrum amplification. From first spark of an idea to
              Pan-India resonance — executed under one creative command.
            </p>

            {/* decorative arc */}
            <div
              className="absolute -right-24 -bottom-24 w-80 h-80 rounded-full border border-yellow-300/30"
              style={{ boxShadow: "inset 0 0 60px rgba(255,222,0,0.08)" }}
            />
            <div className="absolute -right-32 -bottom-32 w-[420px] h-[420px] rounded-full border border-yellow-300/10" />
          </div>
        </Reveal>

        {/* Deployments */}
        <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-5">
          {DEPLOYMENTS.map((d, i) => {
            const Icon = d.icon;
            return (
              <Reveal key={d.label} delay={i * 0.06}>
                <div
                  className="glass-card hud-corners p-6 md:p-7 h-full flex items-start gap-4 group"
                  data-testid={`whatwedo-${d.label.toLowerCase().replace(/\s+/g, "-")}`}
                >
                  <span className="hud-tr" />
                  <span className="hud-bl" />
                  <div
                    className="w-11 h-11 flex items-center justify-center border flex-none"
                    style={{
                      borderColor: `${d.color}55`,
                      color: d.color,
                      boxShadow: `0 0 14px ${d.color}22`,
                    }}
                  >
                    <Icon size={18} strokeWidth={1.4} />
                  </div>
                  <div>
                    <div className="micro-label" style={{ color: d.color }}>
                      DEPLOY · {String(i + 1).padStart(2, "0")}
                    </div>
                    <div className="font-display font-bold uppercase text-lg md:text-xl tracking-tight mt-1">
                      {d.label}
                    </div>
                    <div className="text-white/50 text-sm mt-1">{d.note}</div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </SectionWrapper>
  );
};

export default WhatWeDo;
